export default {
    placeholderUri: (width, height, color) => {
        width = Number(width);
        height = Number(height);
        color = color || '#808080';

        let svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}">`;
        svg += `<rect x="0" y="0" width="${width}" height="${height}" fill="#808080" />`;
        svg += `</svg>`;
        return `data:image/svg+xml;base64,${btoa(svg)}`;
    },

    makeTranslator: (translations) => {
        // use %s placeholder to insert arguments
        return (key, ...args) => {
            let translation = translations[key];
            if (translation === undefined) {
                console.warn(`Translation for key "${key}" not found`);
                return key;
            }

            let result = translation;
            for (let i = 0; i < args.length; i++) {
                result = result.replace('%s', args[i]);
            }
            return result;
        }
    }
}
